import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OwnerComponent } from './owner.component';
import { AuthGuard } from 'src/app/auth/auth.guard';

import { OwnerDashboardComponent } from './owner-dashboard/owner-dashboard.component';

import { OwnerParkComponent } from './owner-park/owner-park.component';
import { PostNewCarComponent } from './post-new-car/post-new-car.component';

import { DealerAccountComponent } from '../dealer/dealer-account/dealer-account.component';
import { DealerAppointmentsComponent } from '../dealer/dealer-appointments/dealer-appointments.component';
import { DealerPublicComponent } from '../dealer/dealer-public/dealer-public.component';
import { DealerMyProvidersComponent } from '../dealer/dealer-myproviders/dealer-myproviders.component';
import { DealerContractsComponent } from '../dealer/dealer-contracts/dealer-contracts.component';
import { DealerConversationsComponent } from '../dealer/dealer-conversations/dealer-conversations.component';
import { ProviderBuyComponent } from '../provider/provider-buy/provider-buy.component';
import { ProviderRentComponent } from '../provider/provider-rent/provider-rent.component';
import { DealerNotificationsComponent } from '../dealer/dealer-notifications/dealer-notifications.component';
import { DealerSearchComponent } from 'src/app/public/account/elements/dealer-search/dealer-search.component';

const routes: Routes = [
  {
    path: '', component: OwnerComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: OwnerDashboardComponent },

      { path: 'account', canActivate: [AuthGuard], component: DealerAccountComponent },
      { path: 'dashboard', component: OwnerDashboardComponent },

      { path: 'park', canActivate: [AuthGuard], component: OwnerParkComponent },
      { path: 'buy', canActivate: [AuthGuard], component: ProviderBuyComponent },
      { path: 'rent', canActivate: [AuthGuard], component: ProviderRentComponent },

      { path: 'my-providers', component: DealerMyProvidersComponent },

      { path: 'public', component: DealerPublicComponent },

      { path: 'appointments', canActivate: [AuthGuard], component: DealerAppointmentsComponent },
      { path: 'conversations', canActivate: [AuthGuard], component: DealerConversationsComponent },
      { path: 'notifications', canActivate: [AuthGuard], component: DealerNotificationsComponent },

      { path: 'contracts', canActivate: [AuthGuard], component: DealerContractsComponent },

      { path: 'post-new-car', component: PostNewCarComponent },

      { path: 'search-provider', component: DealerSearchComponent },

      //{ path: '', redirectTo: '/admin/home', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OwnerRoutingModule { }
